import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalOverlay , ModalHeader , ModalFooter } from "@chakra-ui/modal";
import React from "react";
import Card from "components/card/custom";
import { BsInfoCircleFill } from "react-icons/bs";
import {MdHighlightOff } from "react-icons/md";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

const DetailCard = ({ label, value , is_active }: { label: string; value: string | number | undefined ,is_active : any }) => (
  <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
      <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</h3>
      <p className="mt-1 text-base font-semibold text-gray-800 dark:text-gray-100">{(is_active) ? value : 'N/A'}</p>
  </div>
);
const InfoModal = ({ info, varient , type }: { info?: any, varient?: string , type : any}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCloseModal, setIsCloseModal] =  React.useState<boolean>(false);
  const handleClose = () => {
    setIsCloseModal(true)
    setTimeout(() => {
      setIsCloseModal(false)
      onClose();
    }, 300);
  };
  const safeJSONParse = (input: any, defaultValue: any) => {
      try {
          const parsed = JSON.parse(input);
          return parsed ?? defaultValue;
      } catch {
          return defaultValue;
      }
  };

  return (
    <>
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <button className="flex disabled:opacity-50 disabled:cursor-not-allowed items-center justify-center gap-2 whitespace-nowrap px-3 py-2 text-blue-500 outline-none dark:text-gray-200" onClick={() => { onOpen() }} disabled={!info}>
            <BsInfoCircleFill className={varient === "small" ? "h-4 w-4" : "w-5 h-5"} />
          </button>
        </PopoverTrigger>  
        <Portal > 
          <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
            <PopoverHeader>
              <span className="text-sm  font-bold text-white">
            View Velocity Information
            </span>
            </PopoverHeader>
            <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
          </PopoverContent>
        </Portal>
      </Popover>
      
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
            isOpen && !isCloseModal ? "card-enter" : "card-exit"
          }`}>
            <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">            
              <MdHighlightOff className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white" onClick={handleClose}/>
              KYC Velocity Data
            </ModalHeader>
            <ModalBody className="p-2">
                <div className="relative flex flex-col mx-[20px] scrollbar-hide space-y-8">
                  <div className="space-y-3">
                    <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">General Info</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <DetailCard label="Country" value={info?.country} is_active={true}/>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Payout Limits</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <DetailCard
                        label="Transaction Limit"
                        value={`${safeJSONParse(info?.transactionLimit, {}).limit_no} / ${safeJSONParse(info?.transactionLimit, {}).period}`}
                        is_active={true}
                      />
                      <DetailCard
                        label="Max Transaction Amount"
                        value={`${safeJSONParse(info?.maxTransactionAmount, {}).amount} ${safeJSONParse(info?.maxTransactionAmount, {}).currency} / ${safeJSONParse(info?.maxTransactionAmount, {}).period}`}
                        is_active={true}
                      />
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                      {["noKyc", "sdd", "edd"].map((level) => {
                        const data = safeJSONParse(info?.[level], {});
                        const labelMap: Record<string, string> = {
                          noKyc: "No KYC",
                          sdd: "SDD",
                          edd: "EDD"
                        };
                        return (
                          <div key={level} className="space-y-4">
                            <h4 className="text-lg font-semibold text-gray-700 dark:text-gray-300">{labelMap[level]}</h4>
                            <DetailCard
                              label="Min Amount Per Transaction"
                              value={`${data.min_amount_per_transaction?.amount} ${data.min_amount_per_transaction?.currency}`}
                              is_active={data.is_active}
                            />
                            <DetailCard
                              label="Max Amount Per Transaction"
                              value={`${data.max_amount_per_transaction?.amount} ${data.max_amount_per_transaction?.currency}`}
                              is_active={data.is_active}
                            />
                            <DetailCard label="KYC Count" value={data.kyc_count?.count} is_active={data.is_active}/>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">Supported Payment Methods</h3>
                    <div className="flex flex-wrap gap-2">
                      {Object.entries(safeJSONParse(info?.paymentMethods, {}))
                        .filter(([_, value]) => value === true)
                        .map(([key]) => (
                          <span
                            key={key}
                            className="px-3 py-2 text-sm rounded-md bg-blue-50 text-blue-700 dark:bg-blue-900 dark:text-blue-300 border border-blue-200 dark:border-blue-700 capitalize"
                          >
                            {key.replace("_", " ")}
                          </span>
                        ))}
                      {Object.values(safeJSONParse(info?.paymentMethods, {})).every(v => v === false) && (
                        <span className="text-sm text-gray-500 italic dark:text-gray-400">No active methods</span>
                      )}
                    </div>
                  </div>
                </div>       
            </ModalBody>
            <ModalFooter className="mt-[10px]">
                <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                  <button 
                    onClick={handleClose} 
                    className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                    // className="outline-none linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                    >
                    Close
                  </button>
                </div>
            </ModalFooter>
        </Card>
      </Modal>
    </>
  );
};
export default InfoModal;
